export function getCurrentDateTimeString() {
  const today = new Date();
  const pad = num => (num < 10 ? '0' + num : num);

  const day = pad(today.getDate());
  const month = pad(today.getMonth() + 1);
  const year = today.getFullYear();
  const hours = pad(today.getHours());
  const minutes = pad(today.getMinutes());
  const seconds = pad(today.getSeconds());

  return `${day}-${month}-${year}_${hours}-${minutes}-${seconds}`;
}

export function getCurrentDateString() {
  const today = new Date();
  const pad = num => (num < 10 ? '0' + num : num);

  return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
}